import type { AgentSessionSummary } from '../stores/agent/types'

// A blank repo on a session row is the default web session — the backend
// runs those against the registry default, superbrain.
export const DEFAULT_SESSION_REPO = 'superbrain'

export interface AgentSessionGroup {
  repo: string
  sessions: AgentSessionSummary[]
}

export function sessionRepo(session: AgentSessionSummary): string {
  return session.repo || DEFAULT_SESSION_REPO
}

// Groups the session list by repo for the Sessions column. Groups keep the
// order in which each repo first appears, so the list's own ordering (most
// recently active first) still decides which repo sits on top.
export function groupSessionsByRepo(sessions: AgentSessionSummary[]): AgentSessionGroup[] {
  const groups = new Map<string, AgentSessionSummary[]>()
  for (const session of sessions) {
    const repo = sessionRepo(session)
    const bucket = groups.get(repo)
    if (bucket) bucket.push(session)
    else groups.set(repo, [session])
  }
  return Array.from(groups, ([repo, items]) => ({ repo, sessions: items }))
}
